'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    if (!data || (typeof data === "undefined" ? "undefined" : _type_of(data)) !== 'object') return;
    var ul = document.createElement('ul');
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        createTree(li, data[key]);
        ul.append(li);
    }
    if (ul.children.length > 0) element.append(ul);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.38d384b5.js.map
